<template>
    <div>
        <p id="error" v-show="error">{{ error }}</p>
        <div class="drop_area" cols="auto" :class="classesDragArea" @dragover.prevent="onArea" @drop.prevent="dropFile" @dragleave.prevent="offArea" @dragend.prevent="offArea">
            <div style="margin-top: 50px;">
                <p>画像をアップロード</p>
                <p>ファイルをドラッグ＆ドロップ</p>
                <label class="file_select v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default" >
                    ファイルを選択<input name="file[]" class="file_input" @change="changeFile" ref="file" type="file" accept=".jpg,.gif,.png,image/gif,image/jpeg,image/png">
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    // import PDFThumbComponent from './PDFThumbComponent.vue';
    
    export default {
        components: {
            // 'pdf-thumb-component': PDFThumbComponent,
        },
        props: {
            dbFileList: Array,
        },
        data () {
            return {
                files: [],
                error: '',
                inArea: false
            };
        },
    
        computed: {
            isError: function () {
                return !!this.error !== '';
            },
            classesDragArea () {
                return {
                    'drag_on': this.inArea
                };
            }
        },
    
        methods: {
            dropFile(e) {
                this.changeFile(e);
                this.offArea();
            },
            /*
            changeFile(e) {
                /*
                const files = e.target.files || e.dataTransfer.files;
                for(let i = 0; i < files.length; i++){
                    if (this.validation(files[i])) {
                        this.files.push(files[i]);
                    } else {
                        // this.files = {};
                    }
                    // files.push(fileList[i]);
                }

                // 親コンポーネントへ値渡し
                this.$emit("triggerEvent", this.files);
                console.log('changeFile')

            },
            */
            getBase64 (file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = () => resolve(reader.result)
                    reader.onerror = error => reject(error)
                })
            },
            changeFile (e) {
                const images = e.target.files || e.dataTransfer.files
                var vali_flag = this.validation(images[0])
                if(vali_flag){
                    this.getBase64(images[0])
                        .then(image => {
                            console.log(images);
                            this.$emit('selectSeal', image);
                            this.$emit('imprintName', images[0]['name']);
                        })
                        .catch(error => this.error = '画像のアップロードに失敗しました。');
                }
            },
            deleteFile (index) {
                /*
                this.dbFileList.splice(index, 1);
                // 親コンポーネントへ値渡し
                this.$emit("triggerEvent2", index);
                */
            },
            validation (file) {
                // if (!this.isAllowFileType(file.type)) {
                //     this.error = this.getErrorMessageType();
                //     return false;
                // }
    
                // if (!this.isAllowFileSize(file.size)) {
                //     this.error = this.getErrorMessageSize();
                //     return false;
                // }
                var max_size = 500;
                if (!['image/png', 'image/jpg', 'image/jpeg', 'image/gif'].includes(file.type)) {
                    this.error = "PNG、JPG、JPEG、GIF以外は利用できません。";
                    return false;
                }else if(file.size >= max_size * 1024){
                    this.error = "500KB未満の画像を選択してください。";
                    return false;
                }
                this.error = '';
                return true;
            },
            onArea  () { this.inArea = true;  },
            offArea () { this.inArea = false; }
        }
    };
</script>

<style scoped>
    .file_input {
        display: none;
    }
    .file_select:hover {
        cursor: pointer;
    }
    #error {
        color: #d70035;
    }
    .drop_area {
        width: 300px;
        height: 300px;
        padding: 10px;
        text-align: center;
        border: 1px dashed #c6c6c6;
        border-radius: 50%;
        background-color: #f9f9f9;
        
        text-align: center;
        margin: 0 auto;
    }
    .drag_on {
        border: 2px dashed #bcbcbc;
        background-color: #fafdff;
    }
</style>